import { Button } from 'components/elements'
import { getAlphaRgb } from 'components/layouts'
import styled from 'styled-components'

import * as S from '../components/Static.styles'

const defaultProps = {}
const propTypes = {}

const Hero = styled.header`
  max-width: 750px;
  margin: 0 auto 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const Kicker = styled.span`
  ${({ theme }) => theme.font.label}
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 8px;
`

const Title = styled.h1`
  ${({ theme }) => theme.font.h2}
  color: ${({ theme }) => theme.colors.black};
  margin: 0 0 16px;
`

const Lead = styled.p`
  ${({ theme }) => theme.font.body}
  font-style: italic;
  color: ${({ theme }) => theme.colors.grey};
  margin: 0;
`

const Content = styled.div`
  max-width: 750px;
  margin: 0 auto;
`

const CtaCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 40px;
  padding: 24px 20px;
  border: 1px solid ${({ theme }) => theme.colors.grey2};
  border-radius: 8px;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.white} 0%,
    ${({ theme }) => getAlphaRgb(theme.colors.primaryL, 0.35)} 100%
  );
`

const CtaText = styled.p`
  ${({ theme }) => theme.font.body}
  margin: 0 0 16px;
`

export const ParentSurvey = () => {
  return (
    <S.Article>
      <Hero>
        <Kicker>Parent Survey</Kicker>
        <Title>
          Understanding Autism: A Parent Survey of Early Development
        </Title>
        <Lead>
          For parents of autistic children under age 20&mdash;with any
          developmental history.
        </Lead>
      </Hero>
      <Content>
        <p>
          TrialSite News is inviting parents of autistic children to take part
          in a short survey about their child&rsquo;s early development. Every
          developmental history is welcome&mdash;whether your child showed
          differences from the very beginning, developed typically at first, or
          experienced changes along the way.
        </p>
        <p>
          The goal is to help researchers better understand the developmental
          patterns that occur before and around the time the first signs of
          autism appear. By bringing many families&rsquo; experiences together
          in one place, we hope to surface patterns that no single story can
          reveal on its own.
        </p>
        <p>
          The survey results will be made publicly available, so that
          researchers, clinicians, and families around the world can benefit
          from what we learn together.
        </p>
        <CtaCard>
          <CtaText>
            If you are the parent of an autistic child under age 20, we invite
            you to share your experience. <br />
            The survey only takes about 3 minutes to complete.
          </CtaText>
          <Button
            variant="contained"
            color="primary"
            href="https://airtable.com/appxoW7SrCrtEvPqH/pagzn0t7cDDTh7sKA/form"
            target="_blank"
            rel="noreferrer"
          >
            Join the study
          </Button>
        </CtaCard>
      </Content>
    </S.Article>
  )
}

ParentSurvey.defaultProps = defaultProps
ParentSurvey.propTypes = propTypes

export default ParentSurvey
